import * as angular from "angular";
import {IController, ILogService, ITimeoutService} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../../account/angular/models/account.model";
import {LocationType} from "../../../commons/types/location.type";
import {AddressesService} from "../../../addresses/services/addresses-service.factory";
import {SplitService} from "../../../commons/services/split-service.service";
import {OrdersService} from "../../services/orders-service.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {PackageConfigurationService} from "../../../site-preferences/services/package-configuration-service.service";
import {TaskPurposeType} from "../../../commons/types/task-purpose.type";
import {PredefinedSkillType} from "../../../skills/types/predefined-skill.type";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {ServicesViewsStateType} from "../../../deliveries/types/services-views-state.type";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";

export class createOperationCtrl implements IController {

  order: any;
  account: AccountModel;
  billingAccount: any;
  pricePlanBundle: any;
  isDuplicate: boolean;
  isEdit: boolean;
  loading: boolean;
  quote: any;

  onSubmit: Function;
  onCancel: Function;

  public isShouldSendSms: boolean;
  public siteInfo: any;

  private vehicleTypes: any;
  private availableDays: any;
  private skillOptions: any;
  private customer: any;
  private depotMode: boolean;
  private customAddressEnabled: boolean;
  private addMarker: any;
  private programHasChanged: boolean;
  private subTaskOptions: any;
  private selectedSubTaskType: any;
  private isAddCustomSubTask: boolean;
  private isCustomSubTaskMapByTaskId: any;
  private selectedRelatedType: any;
  private selectedDate: any;
  private selectedQuote: any;
  private quotes: any;
  private addressZoneId: string;
  private defaultItemSize: any;
  private packageSizes: any;
  private showPrice: boolean;
  private enableDateEdit: boolean;
  private pricePlanType: string;
  public accountIds: string[];
  private identificationOptions: any;
  enableDisplayAllCustomers?: boolean;

  public canCreateTag: boolean;

  public locationTypes: typeof LocationType = LocationType;
  public cashOnDeliveryActionTypesMap: any;
  public newRelatedTasksMap: any = {};
  public enablePackageEdit: boolean;
  public orderCopy: any;
  public canUpdateExternalId: boolean;
  public viewFormSettings: ViewSettingsModel;
  public useLegacyServiceTime: boolean;


  /* @ngInject */
  constructor(private $log: ILogService, private ordersService: OrdersService, private tasksConstants, private deliveriesService: DeliveriesService,
              private commonsAlertsService: CommonsAlertsService, private moment, private $timeout: ITimeoutService, private siteContextService: SiteContextService, private packageConfigurationService: PackageConfigurationService,
              private confirmChangeStateService: ConfirmChangeStateService, private addressesService: AddressesService,
              private splitService: SplitService, private IAMPermissions, private viewSettingsService: ViewSettingsService) {
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.locationTypes = LocationType;
    this.canUpdateExternalId = this.IAMPermissions.hasPermission('services.update.externalId');
    this.enableDisplayAllCustomers = this.splitService.getServiceEnableDisplayAllCustomers();
  }

  $onInit() {
    this.cashOnDeliveryActionTypesMap = {
      Collect: true,
      Payment: true
    };

    this.useLegacyServiceTime = this.isEdit ?
      !this.order.serviceList[0].taskList[0].taskSpec.detailedServiceTime :
      this.splitService.getUseLegacyServiceTime();


    this.canCreateTag = this.IAMPermissions.hasPermission('infoTags.create');
    this.vehicleTypes = [];
    this.packageSizes = [];
    this.availableDays = [];
    this.skillOptions = [];
    this.depotMode = false;
    this.customAddressEnabled = false;
    this.addMarker = {enabled: false};
    this.programHasChanged = false;
    this.pricePlanType = this.isEdit ? this.order.pricePlanType : this.order.serviceList[0].pricePlanType;
    this.subTaskOptions = [];
    this.isAddCustomSubTask = false;
    this.isCustomSubTaskMapByTaskId = {};
    this.selectedRelatedType = this.tasksConstants.relationTypes[0];
    this.isShouldSendSms = true;
    this.enableDateEdit = false;
    this.addressZoneId = undefined;

    this.identificationOptions = {
      Operation: [],
    };

    // Sets the transition from this component as confirm prompt
    this.confirmChangeStateService.setIsEnabled(true);

    // Load quotes after settings, only if its create
    const reloadQuotes = !this.isEdit || !this.isDuplicate;

    this._loadOrderSettings(this.pricePlanType, true, reloadQuotes);

    this.orderCopy = angular.copy(this.order);

    this._initViewSettings();

    // if (!this.isEdit) {
    //   // For new quote implementation (need to call quotes again for getting the full list and not only freestyle.
    //   this._loadQuotes(this.pricePlanType);
    // }
  };

  $onChanges(changes) {
    if (changes.order && !changes.order.isFirstChange()) {
      if (changes.order.currentValue) {
        this.orderCopy = angular.copy(this.order);
        if (!this.isEdit) {
          this._loadOrderSettings(changes.order.currentValue.serviceList[0].pricePlanType, false);
          this._loadQuotes(changes.order.currentValue.serviceList[0].pricePlanType);
        }
      }
    }
    if (changes.account) {
      this.accountIds = this.account?.id ? [this.account.id] :
        (this.order?.accountId ? [this.order.accountId] : []);
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  onPackageChange(packageItem, index) {
    _.set(packageItem, 'size', packageItem.type);
    _.unset(packageItem, 'type');

    const itemsCopy = angular.copy(this.order.serviceList[0].packageList[0].items);

    itemsCopy[index] = packageItem;
    this.order.serviceList[0].packageList[0].items = itemsCopy;
  }

  togglePrice() {
    this.showPrice = !this.showPrice;
  }

  onRelationTypeChange(relationType) {
    this.selectedRelatedType = relationType;
  }

  onLocationTypeChange(task, locationType: LocationType) {

    if (!task.taskSpec.locationDetails) {
      task.taskSpec.locationDetails = {}
    }

    if (!task.taskSpec.contact) {
      task.taskSpec.contact = {}
    }

    task.taskSpec.locationDetails.locationType = locationType;
    _.unset(task, 'locationDetails.id');

    //CUSTOMER
    this.customer = undefined;
    _.unset(task, 'customerId');

    // CONTACT
    // _.unset(task.taskSpec.contact, 'name');
    // _.unset(task.taskSpec.contact, 'businessName');
    // _.unset(task.taskSpec.contact, 'phoneNo');
    // _.unset(task.taskSpec.contact, 'additionalPhoneNo');
    // _.unset(task.taskSpec.contact, 'email');

    // DEPOT
    task.depotReference = {};
  }


  onAccountLocationSelect(task, account) {
    task.taskSpec.locationDetails.id = _.get(account, 'id');
    task.taskSpec.contact.businessName = _.get(account, 'name');
    task.taskSpec.contact.name = _.get(account, 'name');
    task.taskSpec.contact.phoneNo = _.get(account, 'phoneNumber');
    task.taskSpec.contact.additionalPhoneNo = _.get(account, 'additionalPhoneNo');

    this.onAddressChange(_.get(account, 'address'), task);
  }

  onDepotLocationSelect(task, depot) {
    task.depotReference = {};
    task.depotReference.id = _.get(depot, 'id');

    task.taskSpec.locationDetails.id = _.get(depot, 'id');
    task.taskSpec.contact.businessName = _.get(depot, 'name');
    task.taskSpec.contact.name = _.get(depot, 'contactName');
    task.taskSpec.contact.phoneNo = _.get(depot, 'phoneNumber')
    task.taskSpec.contact.additionalPhoneNo = _.get(depot, 'additionalPhoneNo');

    this.onAddressChange(_.get(depot, 'address'), task);
  }

  onCustomerLocationSelect(task, customer) {
    task.customerId = _.get(customer, 'id');
    task.taskSpec.locationDetails.id = _.get(customer, 'id');
    task.taskSpec.contact.name = this._getCustomerName(customer);
    task.taskSpec.contact.businessName = _.get(customer, 'businessName');
    task.taskSpec.contact.phoneNo = _.get(customer, 'phone');
    task.taskSpec.contact.additionalPhoneNo = _.get(customer, 'additionalPhone');
    task.taskSpec.contact.email = _.get(customer, 'email');

    this.customer = customer;

    const address = _.find(customer.addresses, (a) => {
      return a.id === customer.defaultAddressId;
    })
    if (address) {
      this.onAddressChange(address, task);
    }
  }

  onReferenceIdsChange(referenceIds) {
    this.order.serviceList[0].referenceIds = referenceIds;
  }


  // onCustomerSelect(customer, task) {
  //   this.customer = customer;
  //
  //   task.taskSpec.customerId = customer.id;
  //   task.taskSpec.contact.name = this._getCustomerName(customer);
  //   task.taskSpec.contact.businessName = _.get(customer, 'businessName');
  //   task.taskSpec.contact.phoneNo = _.get(customer, 'phone');
  //   task.taskSpec.contact.additionalPhoneNo = _.get(customer, 'additionalPhoneNo');
  //   task.taskSpec.contact.email = _.get(customer, 'email');
  // }

  // onSearchCustomerChange(searchText, task) {
  //   const customerName = this._getCustomerName(this.customer);
  //
  //   if (!searchText || customerName !== searchText) {
  //     this.customer = undefined;
  //     task.taskSpec.customerId = undefined;
  //     task.taskSpec.contact.name = searchText;
  //   }
  // }

  onIdentificationsChange(identifications, taskRef) {
    taskRef.taskSpec.identifications = identifications
  }

  onPricePlanChange(pricePlan) {
    this.$log.debug('onPricePlanChange', pricePlan);
    this.programHasChanged = true;
    this.pricePlanType = pricePlan.type;
    this._loadOrderSettings(pricePlan.type, false, true);
  }

  setQuotesByDate(date) {
    const from = this.splitService.getStartDayTimestamp(date);
    const to = this.splitService.getEndDayTimestamp(date);

    this._loadQuotes(this.pricePlanType, from, to);
  }

  onQuoteChange(quote) {
    this._assignQuote(quote);
  }

  onLocationButtonToggle() {
    this.addMarker.enabled = !this.addMarker.enabled;
  }

  onToggleCustomAddress() {
    this.customAddressEnabled = !this.customAddressEnabled;
    this.addMarker.enabled = this.customAddressEnabled;
    if (!this.customAddressEnabled) {
      this.addMarker.enabled = false;
    }
  }

  onTaskLocationSelect(location) {
    this.$timeout(0).then(() => {
      _.forEach(this.order.serviceList[0].taskList, (t) => {
        t.taskSpec.address.location = this.addressesService.getAddressLocation(location.lat, location.lng);
      })
    });
  }

  onPhoneChange(task, phone) {
    task.taskSpec.contact.phoneNo = phone;
  }

  onAdditionalPhoneChange(task, additionalPhoneNo) {
    task.taskSpec.contact.additionalPhoneNo = additionalPhoneNo;
  }

  onToggleDepot(taskRef) {
    this.depotMode = !this.depotMode;
    if (this.depotMode) {
      taskRef.taskSpec.contact.name = undefined;
    } else {
      taskRef.taskSpec.depotReference = undefined;
      taskRef.taskSpec.contact.businessName = undefined;
      taskRef.taskSpec.address = this.account.address;
    }
  }

  onDepotSelect(depot, taskRef) {
    if (!!depot) {
      taskRef.taskSpec.depotReference = {
        id: depot.id
      };
    } else {
      taskRef.taskSpec.depotReference = undefined;
    }
    taskRef.taskSpec.contact.businessName = _.get(depot, 'name');
    taskRef.taskSpec.contact.phoneNo = undefined;
    taskRef.taskSpec.contact.additionalPhoneNo = undefined;
    this.onAddressChange(_.get(depot, 'address'), taskRef);
  }

  onSkillSelect(skills) {
    this.order.serviceList[0].requiredSkills = skills
  }

  onAddRelatedTask(relatedTask, task) {
    if (relatedTask) {
      if (!task.relations) {
        task.relations = [];
      }
      task.relations.push(
        {
          type: this.selectedRelatedType,
          relatedTaskId: relatedTask.id,
          details: {
            serviceType: relatedTask.serviceType,
            taskPurpose: relatedTask.taskSpec.purpose,
            serviceId: relatedTask.serviceId,
            serviceExternalId: relatedTask.serviceExternalId,
            accountId: relatedTask.account.id,
            accountName: relatedTask.account.name,
            agentId: _.get(relatedTask, 'agent.id'),
            agentFirstName: _.get(relatedTask, 'agent.user.firstName'),
            agentLastName: _.get(relatedTask, 'agent.user.lastName'),
            status: relatedTask.status
          }
        }
      );
      task.relations = _.uniqBy(task.relations, 'relatedTaskId');
      this.newRelatedTasksMap[relatedTask.id] = true;
    }
  }

  onRemoveRelatedTask(task, $index) {
    task.relations.splice($index, 1);
  }

  onAddressChange(address, taskRef) {
    taskRef.taskSpec.address = address;
    if (!_.isEmpty(address)) {
      const from = this.moment(this.selectedDate).startOf('day').valueOf();
      const to = this.moment(this.selectedDate).endOf('day').valueOf();

      this._loadQuotes(this.pricePlanType, from, to);
    }
  }

  onAddSubTaskToTask(task, subtask) {
    if (subtask.actions?.length) {
      subtask.actions = this._getSubTaskActionsWithDefaults(subtask);
    }


    if (task) {
      if (!task.subTasks) {
        task.subTasks = [];
      }
      task.subTasks.unshift(angular.copy(subtask));
    }
  }

  onRemoveSubtask(task, subtask, index) {
    if (task) {
      task.subTasks.splice(index, 1);
      if (!task.subTasks?.length) {
        task.subTasks = undefined;
      }
    }
  }

  onAddAttachment() {
    this.deliveriesService.addDeliveryAttachments()
      .then((attachment) => {
        if (!this.order.serviceList[0].attachments) {
          this.order.serviceList[0].attachments = [];
        }
        this.order.serviceList[0].attachments.push(attachment);
      })
  }

  onRemoveAttachment(index) {
    this.order.serviceList[0].attachments.splice(index, 1);
  }

  onTagsChange(tagNames) {
    this.order.serviceList[0].tagNames = tagNames;
  }

  onEditDate() {
    this.enableDateEdit = true;
  }

  onRedoDate() {
    this.enableDateEdit = false;
    this.quotes = null;

    this._loadQuotes(this.pricePlanType, undefined, undefined, true);
  }

  onEditPackage() {
    this.enablePackageEdit = true;
  }

  onRedoPackage() {
    this.enablePackageEdit = false;
    this.order.serviceList[0].packageList[0].items = this.orderCopy.serviceList[0].packageList[0].items;
  }


  onSubTasksChanged(task, subTasks) {
    if (task) {
      task.subTasks = subTasks;
    }
  }


  onChangeServiceTime(task, serviceTime) {
    task.taskSpec.serviceTime = serviceTime;
  }


  onChangeDetailedTimeValue(serviceTimeType, value, task) {
    task.taskSpec.detailedServiceTime[serviceTimeType] = value;
  }

  submit(form) {
    form.$setSubmitted();
    if (form.$valid) {
      this.onSubmit({order: this.order, isShouldSendSms: this.isShouldSendSms, form: form})
    } else {
      this.commonsAlertsService.formInvalidInfo();
    }
  }

  // ******************************
  //        Private methods
  // ******************************

  _getCustomerName(customer) {
    if (!customer) {
      return undefined;
    }
    return _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '');
  }

  _loadOrderSettings(selectedPricePlanType, isInit?, reloadQuotes?) {
    this.ordersService.getOrderSettings(this.order.accountId, this.order.serviceList[0].serviceType, selectedPricePlanType)
      .then((orderSettings) => {
        const serviceRef = orderSettings;

        this.order.serviceList[0].taskList[0].taskValidationList = undefined;

        orderSettings.enabledServiceValidations?.forEach((validation) => {
          if (validation.enabledTaskPurpose?.includes(TaskPurposeType.Operation)) {
            if (!this.order.serviceList[0].taskList[0].taskValidationList) {
              this.order.serviceList[0].taskList[0].taskValidationList = [];
            }
            this.order.serviceList[0].taskList[0].taskValidationList.push(validation);
          }
        })

        this.order.serviceList[0].pricePlanType = selectedPricePlanType;
        this.order.pricePlanType = selectedPricePlanType;
        this.availableDays = _.get(serviceRef, 'availableDays', []);

        const today = _.find(this.availableDays, (d) => {
          return this.moment().isSame(this.moment(d), 'day');
        })
        this.selectedDate = this.availableDays.length ? this.moment(today || _.head(this.availableDays)).toDate() : undefined;
        this.skillOptions = _.uniq(_.get(serviceRef, 'enabledSkills', []).concat([PredefinedSkillType.Merchandise]));
        this.order.serviceList[0].requiredSkills = _.get(serviceRef, 'defaultSkills', []);

        if (!this.order.serviceList[0].requiredSkills?.length) {
          this.order.serviceList[0].requiredSkills = [PredefinedSkillType.Merchandise];
        }

        this.subTaskOptions = [];

        serviceRef.optionalSubTasks.forEach(optionalSubTask => {
          if (optionalSubTask.purposes.includes(TaskPurposeType.Operation)) {
            this.subTaskOptions.push(optionalSubTask);
          }
        })

        this.selectedSubTaskType = _.get(this.subTaskOptions, '[0]');
        this.isAddCustomSubTask = _.isLength(this.subTaskOptions);

        if ((!this.isDuplicate && !this.isEdit) || (!isInit && (this.isDuplicate || this.isEdit))) {
          this.order.serviceList[0].requiredSkills = _.get(orderSettings, 'defaultSkills', []);
          if (!this.order.serviceList[0].requiredSkills?.length) {
            this.order.serviceList[0].requiredSkills = [PredefinedSkillType.Merchandise];
          }

          _.forEach(this.order.serviceList[0].taskList, (t) => {
            if (this.useLegacyServiceTime) {
              _.unset(t.taskSpec, 'detailedServiceTime');
              t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.operationDetailedServiceTime.generatedTotalTime', 0);
            } else {
              _.unset(t.taskSpec, 'serviceTime');
              t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.operationDetailedServiceTime', {})
            }
            t.subTasks = [];
            serviceRef.defaultSubTasks.forEach(defaultSubTask => {
              if (defaultSubTask.purposes.includes(t.taskSpec.purpose)) {
                t.subTasks.push(defaultSubTask);
              }
            })

            t.subTasks?.forEach(st => {
              st.actions = this._getSubTaskActionsWithDefaults(st);
            })
          })
        }

        this.packageSizes = serviceRef.itemSizeList;
        this.defaultItemSize = serviceRef.defaultItemSize;
        if (!_.get(this.order.serviceList[0], 'packageList')) {
          this.order.serviceList[0].packageList = [];
          this.order.serviceList[0].packageList[0] = {};
          this.order.serviceList[0].packageList[0].items = [];
        }

        if (reloadQuotes && (!this.isEdit || this.isEdit && this.enableDateEdit)) {
          this.setQuotesByDate(this.selectedDate);
        }

        if ((!this.isDuplicate && !this.isEdit) || !_.get(this.order, 'serviceList[0].packageList[0].items.length')) {
          const defaultItemSizeItem = _.find(this.packageSizes, (p) => {
            return p.itemSize === _.get(serviceRef, 'defaultItemSize');
          });
          if (defaultItemSizeItem) {
            this.order.serviceList[0].packageList[0].items = [
              {
                count: 1,
                barcode: null,
                size: defaultItemSizeItem.itemSize || 'NoPackage',
                labels: defaultItemSizeItem.labels || [],
                dimensions: angular.copy(defaultItemSizeItem.dimensions) || {},
                weight: defaultItemSizeItem.weight
              }
            ];
          }
        }

        this.identificationOptions = {
          Operation: this.ordersService.buildIdentificationOptions(
            _.get(serviceRef, 'dropoffPodSettings'),
            _.get(serviceRef, 'dropoffPodFillRequiredSettings')
          )
        };

        if (!this.isDuplicate && !this.isEdit) {
          this._setTasksDefaultIdentification(
            _.get(serviceRef, 'dropoffPodSettings'),
            _.get(serviceRef, 'dropoffPodFillRequiredSettings')
          );
        }

        // if (_.get(this.order.serviceList[0], 'packageList') && !_.get(this.order.serviceList[0].packageList[0], 'items')) {
        //   this.order.serviceList[0].packageList[0].items = [];
        // }
        // if (!this.isDuplicate) {
        //   if (!_.isLength(this.order.serviceList[0].packageList) || !_.isLength(this.order.serviceList[0].packageList[0].items)) {
        //     const defaultItemSizeItem = _.find(this.packageSizes, (p) => {
        //       return p.itemSize === _.get(serviceRef, 'defaultItemSize');
        //     });
        //     if (defaultItemSizeItem) {
        //       this.order.serviceList[0].packageList = [];
        //       this.order.serviceList[0].packageList[0].items = [];
        //     }
        //   }
        // } else {
        //   this.isDuplicate = false;
        // }


      })
  }

  _loadQuotes(selectedPricePlanType, from?, to?, isReloadQuote?) {

    if (this.order.serviceList[0].taskList[0]?.taskSpec?.address &&
      !!Object.keys(this.order.serviceList[0].taskList[0]?.taskSpec?.address).length) {
      const services = this._getServices(this.order);

      this.ordersService.getOrderQuote(services, this.order.accountId, selectedPricePlanType, from, to)
        .then((service) => {
          this.quotes = service.quotes;
          this.addressZoneId = _.get(service, 'destinationZoneId');

          const todayQuote = _.find(service.quotes, (q) => {
            return this.moment(q.startTime).isSame(this.moment(), 'day');
          });
          this._assignQuote(todayQuote || _.get(this.quotes, '[0]'), isReloadQuote);
        })
    }
  }

  _assignQuote(quote, isReloadQuote?) {
    this.selectedQuote = angular.copy(quote);

    if (_.get(quote, 'type') === 'PerTask') {
      quote = quote.quotes[0];
    }

    this.selectedDate = quote ? new Date(_.get(quote, 'startTime')) : undefined;

    if ((!this.isEdit || this.isEdit && this.enableDateEdit) && quote && !isReloadQuote) {
      this.deliveriesService.updateDeliveryQuote(this.order.serviceList[0], quote);
    }
  }

  _getServices(order) {
    const services = [{
      serviceType: order.serviceList[0].serviceType,
      tasks: []
    }];
    order.serviceList[0].taskList.forEach((task: TaskModel) => {
      services[0].tasks.push({
        purpose: task.taskSpec.purpose,
        address: task.taskSpec.address,
        depotId: _.get(task, 'taskSpec.depotReference.id'),
        serviceTimeInMillis: _.get(task, 'taskSpec.serviceTime')
      });
    });
    return services;
  }

  _setTasksDefaultIdentification(dropoffPodSettings, dropoffPodFillRequiredSettings) {
    const defaultDropoffIdentification = this.ordersService.buildDefaultIdentifications(
      dropoffPodSettings,
      dropoffPodFillRequiredSettings
    );

    _.forEach(this.order.serviceList[0].taskList, (t) => {
      t.taskSpec.identifications = defaultDropoffIdentification;
    });
  }

  private _getSubTaskActionsWithDefaults(subTask) {
    if (!subTask.actions?.length) return [];

    return subTask.actions.map((a) => {

      if (this.cashOnDeliveryActionTypesMap[a.type]) {

        a.paymentMethods = a.paymentMethods?.length ? a.paymentMethods : [{
          method: undefined,
          requestAmount: undefined,
          editable: true
        }];
      }
      return a;
    });
  }

  private _initViewSettings() {
    this.viewSettingsService.getBySite(ServicesViewsStateType.DELIVERIES_FORM_STATE, ViewSettingsType.Form)
      .then((viewSettings: ViewSettingsModel[]) => {
        const userViewFormSettings = viewSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        if (userViewFormSettings) {
          this.viewFormSettings = userViewFormSettings
        } else {
          this.viewFormSettings = viewSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        }
      })
  }

}

angular
  .module('bringoz.admin.orders')
  .component('createOperation', {
    bindings: {
      order: '<',
      account: '<',
      billingAccount: '<',
      pricePlanBundle: '<',
      isDuplicate: '<?',
      isEdit: '<?',
      loading: '<?',
      enableDisplayAllCustomers: '<?',
      quote: '<?',
      onSubmit: '&',
      onCancel: '&'
    },
    template: require('./create-operation.html').default,
    controller: createOperationCtrl
  });
